'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'parachute-box';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f4cd';
var svgPathData = ['M16.1 208l112.1 0c3-97.6 33.4-180.4 75.9-218.2-100.3 22.7-184.1 109.3-188 218.2zm128.1 0l223.5 0C365.8 145.7 352.3 90.4 332.2 50.1 309.9 5.5 282-16 256-16S202.1 5.5 179.8 50.1c-20.1 40.3-33.6 95.6-35.5 157.9zM176 384l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zM307.8-10.2c42.6 37.7 72.9 120.5 75.9 218.2l112.1 0c-3.9-108.8-87.8-195.4-188-218.2z', 'M32.3 224l215.7 0 0 96-24 0c-15.8 0-30.2 5.7-41.3 15.1L32.3 224zM248 208l-103.7 0C146.2 145.7 159.7 90.4 179.8 50.1 202.1 5.5 230-16 256-16s53.9 21.5 76.2 66.1c20.1 40.3 33.6 95.6 35.5 157.9L248 208zm16 16l215.7 0-150.4 111.1C318.2 325.7 303.8 320 288 320l-24 0 0-96zM3.2 222.4L171.8 347c-7.4 10.4-11.8 23.2-11.8 37l0 64c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-64c0-13.8-4.4-26.6-11.8-37L508.8 222.4c2-1.5 3.2-3.9 3.2-6.4 0-140.9-124.1-248-256-248S0 75.1 0 216c0 2.5 1.2 4.9 3.2 6.4zM16.1 208c3.9-108.8 87.8-195.4 188-218.2-42.6 37.7-72.9 120.5-75.9 218.2L16.1 208zm367.6 0c-3-97.6-33.4-180.4-75.9-218.2 100.3 22.7 184.1 109.3 188 218.2l-112.1 0zM224 336l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faParachuteBox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;